import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { RoleFieldClaimsComponent }
	from '@app/modules/system-settings/user-management/roles/role-detail/role-field-claims/role-field-claims.component';

/**
 * Formly field type that hosts a {@link RoleFieldClaimsComponent}.
 *
 * @remarks
 * The field's model value is the array of `FieldClaimsEditModel`. The hosted component edits claim values in place, so
 * when it emits `changed` the control is re-set with the same reference to mark it dirty and notify `valueChanges`
 * subscribers. Set `props.readOnly` (or `props.disabled`) to display the values without allowing changes.
 */
@Component({
	selector: 'formly-role-field-claims',
	standalone: true,
	imports: [RoleFieldClaimsComponent],
	template: `
		<sb-role-field-claims
			[fieldClaims]="formControl.value"
			[readOnly]="!!(props.readOnly || props.disabled)"
			(changed)="onChanged()"
		></sb-role-field-claims>
	`,
})
export class FormlyRoleFieldClaimsComponent extends FieldType<FieldTypeConfig> {
	/** Flags the control as changed after the hosted component mutates the claims in place. */
	onChanged(): void {
		this.formControl.setValue(this.formControl.value);
		this.formControl.markAsDirty();
		this.props.change?.(this.field, this.formControl.value);
	}
}
